import axios from "axios"

export default function getGift({ id }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/items/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}